import { Button, Title } from "@components/atoms";
import { Checkboxs } from "@components/molecules";
import { FormUser } from "@components/organism";
import { urlZaf } from "@services/Zendesk";
import { useNewUser } from "./useNewUser";

export function NewUser() {
    const {
        formData,
        error,
        errorEmail,
        existUser,
        existUserEmail,
        isChecking,
        vinculate,
        setVinculate,
        handleProceed,
        handleChange,
        navigate
    } = useNewUser();

    return (
        <div className="p-4 pb-20">
            <Title title="• Criar usuário" subtitle="Preencha os dados da conta" />
            <FormUser
                formData={formData}
                error={error}
                isChecking={isChecking}
                existUser={existUser}
                urlZaf={urlZaf}
                handleChange={handleChange}
                errorEmail={errorEmail}
                existUserEmail={existUserEmail}
                typeUser={null}
            />

            <div className="fixed bottom-0 left-0 w-full bg-white p-4 border-t border-gray-200">
                <div className="flex flex-col gap-5">

                    <Checkboxs
                        items={{
                            title: "Deseja vincular conta ao ticket?",
                            onChange: () => setVinculate(!vinculate),
                            checked: vinculate
                        }}
                    />
                    <Button
                        isPrimary
                        isStretched
                        onClick={handleProceed}
                        disabled={!formData.name || !formData.email || formData.cpf_3.length !== 11 || isChecking || !!error || !!errorEmail}
                    >
                        Criar usuário
                    </Button>
                    <Button onClick={() => navigate('/')} isStretched>
                        Voltar
                    </Button>
                </div>
            </div>
        </div>
    );
}